import { render, staticRenderFns } from "./recordOrder.vue?vue&type=template&id=7ed7d671&scoped=true"
import script from "./recordOrder.vue?vue&type=script&lang=js"
export * from "./recordOrder.vue?vue&type=script&lang=js"
import style0 from "./recordOrder.vue?vue&type=style&index=0&id=7ed7d671&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed7d671",
  null
  
)

export default component.exports